import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/mh_small_bg_64.png'
import _imports_1 from '../assets/social-icons.svg'


const _hoisted_1 = _imports_1 + '#instagram'
const _hoisted_2 = _imports_1 + '#twitter'
const _hoisted_3 = _imports_1 + '#facebook'
const _hoisted_4 = _imports_1 + '#patreon'
const _hoisted_5 = { class: "site-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("nav", null, null, -1)
const _hoisted_7 = { class: "site-nav" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Mediocre Hobbies"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("nav", { class: "social-nav" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.instagram.com/mediocre_hobbies/",
    target: "_blank",
    class: "social-link"
  }, [
    /*#__PURE__*/_createElementVNode("svg", { fill: "currentColor" }, [
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": _hoisted_1 })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/MediocreHobbies",
    target: "_blank",
    class: "social-link"
  }, [
    /*#__PURE__*/_createElementVNode("svg", { fill: "currentColor" }, [
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": _hoisted_2 })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.facebook.com/MediocreHobbies/",
    target: "_blank",
    class: "social-link"
  }, [
    /*#__PURE__*/_createElementVNode("svg", { fill: "currentColor" }, [
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": _hoisted_3 })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.patreon.com/mediocrehobbies/",
    target: "_blank",
    class: "nav-link"
  }, [
    /*#__PURE__*/_createElementVNode("svg", { fill: "currentColor" }, [
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": _hoisted_4 })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_5, [
    _hoisted_6,
    _createElementVNode("nav", _hoisted_7, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "site-logo"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/",
        class: "nav-link",
        "exact-active-class": "active"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/videos",
        class: "nav-link",
        "active-class": "active"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Videos")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/merch",
        class: "nav-link",
        "active-class": "active"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Merch")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/affiliates",
        class: "nav-link",
        "active-class": "active"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Affiliates")
        ]),
        _: 1
      })
    ]),
    _hoisted_9
  ]))
}